<template></template>

<script setup>
import { onMounted } from 'vue';

const props = defineProps(['redirect_url']);

onMounted(() => {
  if (props.redirect_url) {
    try {
      window.parent.postMessage({
        type: 'idse-redirect',
        url: props.redirect_url
      }, '*');
    } catch (e) {
      window.location.href = props.redirect_url;
    }
  }
});
</script>